export class Spotlight {
    isVisible = false;

    constructor(public headline: string, public description: string, public routerLink: string[], public imageSource: string) { }
}